// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const FindingTypeSourceSchema = z.enum(['AGENT','USER'] as const);

export type FindingTypeSourceType = `${z.infer<typeof FindingTypeSourceSchema>}`

export default FindingTypeSourceSchema;
